import i18n from './locale'
import mainStore from '~/vuestrap/vuexstore'

const addiesaas = window.addiesaas = window.addiesaas || {}
const store = addiesaas.store = addiesaas.store || mainStore

const vuestrap = {store, i18n}

export default vuestrap
